import React from 'react';
import { connect } from 'react-redux';
import IllustratorExportButtons from '../chartview/charts/IllustratorExportButtons';
import { PRINT_ID, SCALE } from './constants';

const ExportButtons = ({ highcharts, activeDoc }) => (
  <IllustratorExportButtons
    highchart={highcharts[PRINT_ID]}
    sizeId={PRINT_ID}
    chart={activeDoc.chart}
    scale={SCALE}
    id={activeDoc.id}
  />
);

function mapStateToProps(state) {
  return {
    activeDoc: state.documents.active ? state.documents.items[state.documents.active] : null,
    highcharts: state.highcharts,
  };
}

export default connect(mapStateToProps)(ExportButtons);
